import React, { useState } from 'react';
import { Image, TouchableOpacity } from '@applane/react-core-components';
import ReactTooltip from 'react-tooltip';
import { Table, Text, Toast } from '../../../app-components';
import { ROUTES } from '../../../Lib/constants';
import { appraisalHoverIcon, appraisalIcon } from '../../../images';
import { getUser, invoke } from '../../../AppServices';
import { dmsURI } from '../../../Queries/dms';
import { modifyDateView, shorten } from '../../../Lib/helpers';

export const notifyAppraisal = async () => {
  const { result } = await invoke({
    id: 'getNotificationPreference',
    paramValue: { dealerId: getUser()?.dealer?._id },
  });
  return result;
};

const ListButton = (props) => {
  const [hover, setHover] = useState(false);

  return (
    <>
      <ReactTooltip
        place="bottom"
        type="dark"
        effect="float"
        id="fi-sale-close-button"
      />

      <TouchableOpacity
        onMouseOver={() => setHover(true)}
        onFocus={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onPress={async () => {
          const { eventDispatcher, navigation } = props;
          eventDispatcher.notify('appLoader', true);
          const { result = {} } = await invoke({
            id: 'appraisalValue',
            paramValue: {
              data: { ...props.item },
            },
          });
          eventDispatcher.notify('appLoader', false);
          if (result && !result.error) {
            const temp = await notifyAppraisal();
            navigation.navigate(ROUTES.viewAppraisalResult.name, {
              item: { _id: result._id, type: result.type },
              showButtonsList: true,
              notifyAppraisal: temp,
            });
          }

          if (result && result.error) {
            Toast.show({
              message: 'Error',
              description: result.error,
              type: 'error',
              position: 'top',
              direction: 'right',
            });
          }
        }}
      >
        <div data-tip="Appraise" data-for="fi-sale-close-button">
          <Image
            style={{
              height: 24,
              width: 24,
              cursor: 'pointer',
              filter:
                'invert(7%) sepia(99%) saturate(7489%) hue-rotate(247deg) brightness(109%) contrast(140%)',
            }}
            source={hover ? appraisalHoverIcon : appraisalIcon}
          />
        </div>
      </TouchableOpacity>
    </>
  );
};

const tableItems = {
  lg: {
    columns: [
      {
        header: 'Repair Order #',
        type: 'text',
        field: 'repairOrderNumber',
        width: 200,
      },
      {
        header: 'Name',
        width: 200,
        render: ({ item }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {shorten(item?.name, 15)}
          </Text>
        ),
      },
      {
        header: 'Email',
        width: 200,
        render: ({ item }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {shorten(item?.email, 12)}
          </Text>
        ),
      },
      {
        header: 'Year',
        type: 'text',
        field: 'year',
        width: 200,
        render: ({ item }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {shorten(item?.year)}
          </Text>
        ),
      },
      {
        header: 'Make',
        type: 'text',
        field: 'make',
        width: 200,
        render: ({ item }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {shorten(item?.make, 12)}
          </Text>
        ),
      },
      {
        header: 'Model',
        type: 'text',
        field: 'model',
        width: 200,
        render: ({ item }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {shorten(item?.model, 17)}
          </Text>
        ),
      },
      {
        header: 'Miles',
        type: 'text',
        field: 'mileage',
        width: 200,
        render: ({ item }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {shorten(item?.mileage?.toString(), 10)}
          </Text>
        ),
      },
      {
        header: 'Open Date',
        // type: 'date',
        // field: 'openDate',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{modifyDateView(item?.openDate)}</Text>
        ),
        width: 200,
      },
      {
        header: 'VIN',
        type: 'text',
        field: 'vin',
        width: 200,
        render: ({ item }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {shorten(item?.vin, 17)}
          </Text>
        ),
      },
      {
        header: 'Actions',
        type: 'text',
        width: 200,
        render: (props) => <ListButton {...props} />,
      },
    ],
  },
};

export default Table({
  uri: dmsURI,
  ...tableItems,
});
